import {
  GET_MARKETING,
  GET_MARKETING_SUCCESS,
  GET_MARKETING_FAIL,
  DELETE_MARKETING,
  DELETE_MARKETING_SUCCESS,
  DELETE_MARKETING_FAIL,
  UPDATE_MARKETING,
  UPDATE_MARKETING_SUCCESS,
  UPDATE_MARKETING_FAIL,
  ADD_NEW_MARKETING,
  ADD_MARKETING_SUCCESS,
  ADD_MARKETING_FAIL,
  MARKETING_LOADING,
  MARKETING_RESET,
} from "./actionType";

export const resetMarketingState = (actionType) => ({
  type: MARKETING_RESET,
  payload: { actionType },
});

export const getMarketingSuccess = (actionType, data) => ({
  type: GET_MARKETING_SUCCESS,
  payload: { actionType, data },
});

export const getMarketingFail = (actionType, error) => ({
  type: GET_MARKETING_FAIL,
  payload: { actionType, error },
});

export const getMarketing = data => ({
  type: GET_MARKETING,
  payload: data,
});

export const getMarketingLoading = () => ({
  type: MARKETING_LOADING
});

export const deleteMarketing = data => ({
  type: DELETE_MARKETING,
  payload: data,
});

export const deleteMarketingSuccess = data => ({
  type: DELETE_MARKETING_SUCCESS,
  payload: data,
});

export const deleteMarketingFail = error => ({
  type: DELETE_MARKETING_FAIL,
  payload: error,
});

export const updateMarketing = data => ({
  type: UPDATE_MARKETING,
  payload: data,
});

export const updateMarketingFail = error => ({
  type: UPDATE_MARKETING_FAIL,
  payload: error,
});

export const updateMarketingSuccess = data => ({
  type: UPDATE_MARKETING_SUCCESS,
  payload: data,
});

export const addNewMarketing = data => ({
  type: ADD_NEW_MARKETING,
  payload: data,
});

export const addMarketingSuccess = data => ({
  type: ADD_MARKETING_SUCCESS,
  payload: data,
});

export const addMarketingFail = error => ({
  type: ADD_MARKETING_FAIL,
  payload: error,
});